// @core/api/endpoints/platform/update_platform_settings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PlatformSettingsResponse,
  UpdatePlatformSettingsRequest,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Update platform settings
 * Updates the platform's configuration settings. Changes may affect all platform members and associated resources.
 */
export async function UpdatePlatformSettings(
  platform_id: string,
  data: UpdatePlatformSettingsRequest,
  options?: RequestOptions
): Promise<PlatformSettingsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id/settings`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  const requestOptions = options;
  return client.put<PlatformSettingsResponse>(requestPath, data, requestOptions);
}
